import * as React from "react";
// import { RouteComponentProps, withRouter } from 'react-router-dom'
import styled from "styled-components";

import Breadcrumb from 'src/presentations/widgets/Breadcrumb';
import { emitWithRouter } from 'src/utils/emitter';
import Header from './Header';
import Content from './Content';
import Footer from './Footer';
import { Location } from 'history';

const StyledPage = styled.div`
  flex-grow: 1;
  overflow-y: hidden;
  overflow-x: hidden;
  height: 100vh;
  position: relative;

  .HeaderRightPopup {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
  }
`;

interface Props {
  /** Whether the page is has a sidebar */
  withSidebar?: boolean;

  withMenubar?: boolean;

  /** Controls the visibility of the user profile button */
  disabledUserProfil?: boolean;

  /** Controls the visibility of the usage button */
  disabledUsagePopup?: boolean;

  /** Controls the visibility of the breadcrumb */
  disabledBreadcrumb?: boolean;

  /** Browser's history location */
  location?: Location;
  children?: React.ReactNode | React.ReactNode[]
}

interface State {
  breadcrumbs: any[] | null;
  userRow: any;
  accountData: {
    stripeCustomerId: string;
    subscriptionId: string;
    currency: string;
    country: string;
    planType: string;
  };
  loadingSubcription: any;
  show: boolean;
  loading: boolean;
  loadingLink: boolean;
  showUserModal: boolean;
  showUpdatePlanModal: boolean;
  currency: string;
}

class PageView extends React.Component<Props, State> {
  // Import sub values
  static Header = Header;
  static Content = Content;
  static Footer = Footer;

  state: State = {
    breadcrumbs: null,
    show: false,
    loading: true,
    loadingLink: false,
    loadingSubcription: "",
    currency: "",
    userRow: {},
    showUserModal: false,
    showUpdatePlanModal: false,
    accountData: {
      stripeCustomerId: "",
      subscriptionId: "",
      planType: "free",
      country: "US",
      currency: "USD",
    },
  };

  async componentDidMount() {
    this.onRouteChanged();
  }

  async componentDidUpdate(prevProps: any) {
    if (this.props.location !== prevProps.location) {
      await this.onRouteChanged();
    }
  }

  /**
   * On route changed
   */
  onRouteChanged = async () => {
    if (this.props.disabledBreadcrumb !== true) {
      // Load nav tab
      let breadcrumbs: any = await emitWithRouter({ event: "breadcrumb" });
      breadcrumbs = breadcrumbs || [];
      this.setState({ breadcrumbs });
    }
  };

  onHide = () => {
    this.setState({ show: false });
  };

  onShow = () => this.setState({ show: true });
  onShowUpdate = () => this.setState({ showUpdatePlanModal: true });
  onShowCustomAPI = () =>
    window.open(
      "https://share.hsforms.com/18A4q7RG2SjSJw39Pqo8LBA41czf",
      "_blank"
    );

  /**
   * Render the main content
   * @returns {any}
   */
  render() {
    return (
      <StyledPage>
        {this.props.disabledBreadcrumb !== true && <div style={{ position: 'relative', marginLeft: 30, marginRight: 30, height:35 }}>
          <Breadcrumb datas={this.state.breadcrumbs} />
        </div>}
        {this.props.children}
      </StyledPage>
    );
  }
}

export default PageView;



// WEBPACK FOOTER //
// ./src/presentations/views/PageView/index.tsx